"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paper = _interopRequireDefault(require("@eig-builder/core-ui/Paper"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withTimeout = _interopRequireDefault(require("./withTimeout"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 90px;\n  height: 90px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  padding-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.withPaddingY ? props.theme.spacing(4) + 'px' : 0;
});

var Backdrop = (0, _styledComponents["default"])(_Paper["default"])(_templateObject2());

var LoaderWithBackdrop = function LoaderWithBackdrop(_ref) {
  var centeredX = _ref.centeredX,
      centeredY = _ref.centeredY,
      className = _ref.className,
      withPaddingY = _ref.withPaddingY,
      passThroughProps = _objectWithoutProperties(_ref, ["centeredX", "centeredY", "className", "withPaddingY"]);

  var wrapperClassNames = (0, _classnames["default"])('d-flex', {
    'justify-content-center': centeredX,
    'align-items-center': centeredY
  }, className);
  return _react["default"].createElement(Wrapper, _extends({
    className: wrapperClassNames,
    withPaddingY: withPaddingY
  }, passThroughProps), _react["default"].createElement(Backdrop, {
    className: "justify-content-center align-items-center"
  }, _react["default"].createElement(_CircularProgress["default"], null)));
};

var _default = (0, _withTimeout["default"])(LoaderWithBackdrop);

exports["default"] = _default;
LoaderWithBackdrop.propTypes = {
  centeredX: _propTypes["default"].bool,
  centeredY: _propTypes["default"].bool,
  withPaddingY: _propTypes["default"].bool,
  className: _propTypes["default"].string
};